import React from "react";
import Translate from "react-translate-component";

class SubmenuItem extends React.Component {
  render() {
    const {
      target,
      text,
      hidden,
      icon
    } = this.props;
    return hidden ? null : /*#__PURE__*/React.createElement("li", {
      onClick: target
    }, /*#__PURE__*/React.createElement(Translate, {
      content: text,
      component: "div",
      className: "table-cell"
    }));
  }

}

export default SubmenuItem;